export default __webpack_public_path__ + "static/media/valleypression_logo_inverse_sans_texte_du_bas_transparent.1b440afc.svg";